import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { LensCatalogBusinessService } from './lens-catalog-business.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class LensCatalogDataLoadedGuardService implements CanActivate {

  constructor(private _router: Router, private lensCatalogBusinessService: LensCatalogBusinessService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    console.log('In LensCatalogDataLoadedGuardService.canActivate');

    // Checking if the initial calls to load data from the Lens Catalog are complete. Continue if so, otherwise redirect to home.
    if (this.lensCatalogBusinessService.dataLoaded) {
      return true;
    } else {
      this._router.navigate(['/home']);
      return false;
    }
  }

}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/shared/lens-catalog-data-loaded-guard.service.ts